import NameSection from '../components/home/NameSection';
import IntroSection from '../components/home/IntroSection';
import RotatingFacts from '../components/home/RotatingFacts';
import SocialLinks from '../components/home/SocialLinks';
import WorkSection from '../components/home/WorkSection';
import ExperienceSection from '../components/home/ExperienceSection';
import BlogPreview from '../components/home/BlogPreview';

const Home = () => {
  return (
    <div>
      <NameSection />
      <IntroSection />
      <RotatingFacts />
      <SocialLinks />
      <BlogPreview />
      <ExperienceSection />
      <WorkSection />
    </div>
  );
};

export default Home;
